import { Printer } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * "Save as PDF" for a report: the browser's own print, which the shell and
 * App.css lay out as the full report on A4 landscape (not one clipped
 * screen). Hidden on paper itself.
 */
export function PrintButton({ label = 'Save as PDF' }) {
  return (
    <Button variant="outline" size="sm" className="print:hidden" onClick={() => window.print()}>
      <Printer className="size-3.5" />{label}
    </Button>
  );
}
